// assets/vh-p2.js — WP-P33 §1: Pages-V2-Bausteinfamilie. ES5-IIFE, 'use strict', kein Dauer-Timer
// (200-ms-Timer-Test, Skill FALLEN.md #2 / CLAUDE.md §5.8): TOC reagiert auf 'scroll' mit
// requestAnimationFrame-Drosselung (kein setInterval), der Rechner nur auf 'input'/'change'.
// Budget ≤ 8 KB Quelle. Geladen zuletzt aus sections/vh-p2-kopf.liquid, nach vh-h2.js.
(function () {
  'use strict';

  // ---------- TOC (sections/vh-p2-prosa.liquid, [data-vh-p2-toc]) ----------
  var tocs = document.querySelectorAll('[data-vh-p2-toc]');
  if (tocs.length) {
    // Review-Fix 25.09.: kein "open" mehr im Markup (mobil sonst immer aufgeklappt) — hier einmalig
    // beim Laden setzen: ab 700px offen (Leiste), darunter zu (Akkordeon). Kein Resize-Listener
    // (Budget/Timer-Regel CLAUDE.md §5.8) — ein Wechsel der Fensterbreite nach dem Laden ist ein
    // Randfall, den die einfache Bauart bewusst nicht abdeckt.
    var vhP2tocOffen = window.matchMedia('(min-width: 700px)').matches;
    for (var ti = 0; ti < tocs.length; ti++) { tocs[ti].open = vhP2tocOffen; }
    var ticking = false;
    var updateToc = function () {
      ticking = false;
      for (var t = 0; t < tocs.length; t++) {
        var toc = tocs[t];
        var ids = toc.getAttribute('data-vh-p2-toc').split(',');
        var current = null;
        for (var i = 0; i < ids.length; i++) {
          var el = document.getElementById(ids[i]);
          if (el && el.getBoundingClientRect().top <= 130) { current = ids[i]; }
        }
        var links = toc.querySelectorAll('a[href^="#"]');
        for (var j = 0; j < links.length; j++) {
          var isCurrent = current !== null && links[j].getAttribute('href') === '#' + current;
          if (isCurrent) {
            links[j].classList.add('is-active');
            links[j].setAttribute('aria-current', 'true');
          } else {
            links[j].classList.remove('is-active');
            links[j].removeAttribute('aria-current');
          }
        }
      }
    };
    var onScroll = function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateToc);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    updateToc();
  }

  // ---------- Rechner (sections/vh-p2-rechner.liquid, [data-vh-p2-rechner]) ----------
  // Logik 1:1 aus fabrik/out/cbd-tropfen-rechner.html portiert (CLAUDE.md §3.2: reine Arithmetik,
  // keine Verzehr-/Dosierempfehlung).
  var rechnerBoxen = document.querySelectorAll('[data-vh-p2-rechner]');
  var fmt = function (n, d) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d });
  };
  var setOut = function (box, key, val) {
    var el = box.querySelector('[data-vh-p2r-out="' + key + '"]');
    if (el) { el.textContent = val; }
  };
  for (var b = 0; b < rechnerBoxen.length; b++) {
    (function (box) {
      var proz = box.querySelector('[data-vh-p2r="proz"]');
      var ml = box.querySelector('[data-vh-p2r="ml"]');
      var tpm = box.querySelector('[data-vh-p2r="tpm"]');
      var ziel = box.querySelector('[data-vh-p2r="ziel"]');
      var zielzeile = box.querySelector('[data-vh-p2r-zielzeile]');
      if (!proz || !ml || !tpm) { return; }
      var calc = function () {
        var p = parseFloat(proz.value);
        var m = parseFloat(ml.value);
        var t = parseFloat(tpm.value);
        if (!(p > 0 && m > 0 && t > 0)) { return; }
        var mgFlasche = p * 10 * m;
        var tropfenFlasche = m * t;
        var mgTropfen = mgFlasche / tropfenFlasche;
        setOut(box, 'mgtropfen', fmt(mgTropfen, 1));
        setOut(box, 'mgflasche', fmt(mgFlasche, 0));
        setOut(box, 'tropfenflasche', fmt(tropfenFlasche, 0));
        var z = parseFloat(ziel ? ziel.value : '');
        if (z > 0 && zielzeile) {
          zielzeile.hidden = false;
          setOut(box, 'zielmg', fmt(z, 0));
          setOut(box, 'zieltropfen', fmt(Math.round((z / mgTropfen) * 10) / 10, 1));
        } else if (zielzeile) {
          zielzeile.hidden = true;
        }
      };
      var felder = [proz, ml, tpm, ziel];
      for (var f = 0; f < felder.length; f++) {
        if (felder[f]) {
          felder[f].addEventListener('input', calc);
          felder[f].addEventListener('change', calc);
        }
      }
      calc();
    })(rechnerBoxen[b]);
  }

  // ---------- Formular: Fokus auf Erfolg-/Fehlermeldung (sections/vh-p2-formular.liquid) ----------
  // Review-Fix 25.09.: Shopify haengt die Formular-id als Fragment an die Action ("/contact#…"), das
  // native autofocus-Attribut greift dann laut HTML-Standard nicht mehr ("flush autofocus candidates"
  // ueberspringt Kandidaten, sobald das Dokument ein Ziel-Element hat). Fallback per JS auf das
  // bereits vorhandene tabindex="-1".
  var vhP2fMsg = document.querySelector('.vh-p2-formular__ok, .vh-p2-formular__fehler');
  if (vhP2fMsg && vhP2fMsg.focus) { vhP2fMsg.focus(); }
})();
